import request from '../utils/request';

// 获取订单列表
export function getOrderList(params) {
    return request({
        url: '/order/get_list',
        method: 'get',
        params
    });
}


// 检查更新订单状态，并同步更新订单账号（激活码）列表
export function syncOrderDetail(params) {
    return request({
        url: '/order/sync',
        method: 'get',
        params
    });
}

// 创建订单
export function createOrder(data) {
    return request({
        url: '/order/create',
        method: 'post',
        data
    });
}
